import axios from 'axios';
import {
  AxiosInstanceWithVersioning,
  VersioningStrategy,
  withVersioning,
} from 'axios-api-versioning';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import authApi from '~/authApi';
import {
  COMPARATOR_TYPES,
  SearchApiCreatorsRequestParams,
  SearchApiCreatorsRequestParamsTTA,
  SearchCreatorsApiResponse,
  SearchCreatorsApiResponseTTA,
} from '~/searchApi';

class SearchCreatorApiClient {
  public _apiInstance: AxiosInstanceWithVersioning;

  private BASE_SEARCH_CREATOR_ENDPOINT_URL = '/creators';

  constructor() {
    const baseClient = axios.create({
      baseURL: `${process.env.NEXT_PUBLIC_SEARCH_RESOURCE}/v{apiVersion}`,
    });

    this._apiInstance = withVersioning(baseClient, {
      apiVersion: '1',
      versioningStrategy: VersioningStrategy.UrlPath,
    });

    this._apiInstance.interceptors.request.use((req) => {
      const { jwtAccessToken } = authApi;

      if (jwtAccessToken) {
        req.headers = {
          ...req.headers,
          'X-AUTH-TOKEN': jwtAccessToken.accessToken,
        };
      }

      return req;
    });

    createAuthRefreshInterceptor(baseClient, (failedRequest) =>
      authApi
        .refreshAccessToken()
        .then((newToken) => {
          failedRequest.response.config.headers['X-AUTH-TOKEN'] =
            newToken?.accessToken;
          if (newToken) {
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        })
        .catch(() => {
          return Promise.reject();
        }),
    );
  }

  public async getCreators(
    params: SearchApiCreatorsRequestParams,
  ): Promise<SearchCreatorsApiResponse> {
    const { data } = await this._apiInstance.post(
      this.BASE_SEARCH_CREATOR_ENDPOINT_URL,
      params,
    );

    return data;
  }

  public async getCreatorById(id: string): Promise<SearchCreatorsApiResponse> {
    const { data } = await this._apiInstance.post(
      this.BASE_SEARCH_CREATOR_ENDPOINT_URL,
      {
        page: 1,
        q_fields: ['slug'],
        filters: [
          {
            comparator: COMPARATOR_TYPES.EQ,
            name: 'id',
            value: id,
          },
        ],
      },
    );

    return data;
  }

  public async getCreatorsTTA(
    params: SearchApiCreatorsRequestParamsTTA,
  ): Promise<SearchCreatorsApiResponseTTA> {
    const { data } = await this._apiInstance.post(
      `${this.BASE_SEARCH_CREATOR_ENDPOINT_URL}/tta`,
      params,
    );

    return data;
  }
}

export const searchCreatorApi = new SearchCreatorApiClient();
